import { Input, Stack } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { FormattedMessage } from 'react-intl'
import { CompactSlider } from '@/components/ui-shared/CompactSlider/CompactSlider'
import { LabelWithHint } from '@/components/ui-shared/LabelWithHint/LabelWithHint'
import {
  MAX_DETECTION_FRAMES,
  MIN_DETECTION_FRAMES
} from '../../LogicSelection/LogicHandler/constants'
import { FormValues } from '../DeploymentSettings'

type DetectionSettingsProps = {
  form: UseFormReturnType<FormValues>
}

export const DetectionSettings = ({ form }: DetectionSettingsProps) => {
  return (
    <Stack gap="lg" py="md">
      <Input.Wrapper
        label={
          <LabelWithHint
            label={
              <FormattedMessage id="deployments.detectionSettings.minDetectionFrames.label" />
            }
            hint={
              <FormattedMessage id="deployments.detectionSettings.minDetectionFrames.description" />
            }
          />
        }
      >
        <CompactSlider
          mt="xl"
          maw={300}
          min={MIN_DETECTION_FRAMES}
          max={MAX_DETECTION_FRAMES}
          marks={[
            {
              value: MIN_DETECTION_FRAMES,
              label: MIN_DETECTION_FRAMES
            },
            {
              value: MAX_DETECTION_FRAMES,
              label: MAX_DETECTION_FRAMES
            }
          ]}
          step={1}
          {...form.getInputProps('minDetectionFrames')}
        />
      </Input.Wrapper>
    </Stack>
  )
}
